( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '[data-component="navigation-five-panel"]' ).on( 'click', function( event ) {
        event.stopPropagation();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-five-panel', COMPONENT );
} )( app );
